import React, { useEffect, useState } from "react";

import { useShopify } from "@app/scripts/react-hooks/shopify";
import { ProductCarousel } from "@app/scripts/react-product-carousel/components/ProductCarousel";
import { shopify } from "@app/scripts/utils/graphql";
import { GET_PRODUCTS_BY_ID } from "@app/scripts/utils/queries";

import type { GQLProduct, NormalisedProduct } from "@app/scripts/types";

type Props = {
  productIds: number[];
  columnsDesktop: number | "auto";
  columnsMobile: number | "auto";
  disabledMobile: boolean;
  disabledDesktop: boolean;
  quickAddStyle?: "default" | "pin" | "plp";
  spaceBetween?: number;
  active?: boolean;
  addToCartBtns?: boolean;
  hasQuickAddDrawer?: boolean;
  addAsGift?: boolean;
  arrowsMobile?: boolean;
};

export const CartCollection: React.FC<Props> = ({
  productIds,
  columnsDesktop,
  columnsMobile,
  disabledDesktop,
  disabledMobile,
  quickAddStyle = "pin",
  spaceBetween = 8,
  active,
  addToCartBtns = false,
  addAsGift = false,
  arrowsMobile = false,
  hasQuickAddDrawer = true,
}) => {
  const [products, setProducts] = useState<NormalisedProduct[]>([]);
  const { normaliseProduct } = useShopify();

  useEffect(() => {
    const getProducts = async () => {
      if (productIds.length) {
        const data = await shopify(GET_PRODUCTS_BY_ID, {
          ids: productIds.map((product) => `gid://shopify/Product/${product}`),
        });

        if (data?.nodes) {
          const filtered = data.nodes
            ?.filter(
              (product: GQLProduct) => product?.handle && !window.location.pathname.includes(`/${product.handle}`)
            )
            ?.map((product: GQLProduct) => normaliseProduct(product));

          if (filtered?.length) {
            setProducts(filtered);
          }
        }
      }
    };
    getProducts();
  }, []);

  return products.length > 0 && active ? (
    <ProductCarousel
      originalClass="product-grid item-carousel columns-desktop__4"
      columnsDesktop={columnsDesktop}
      columnsMobile={columnsMobile}
      disabledDesktop={disabledDesktop}
      products={products}
      disabledMobile={disabledMobile}
      scrollbarMobile={false}
      transparentBtns={false}
      hasQuickAddDrawer={true}
      quickAddStyle={quickAddStyle}
      spaceBetween={spaceBetween}
      showArrows={false}
      showScrollbar={false}
      addToCartBtns={addToCartBtns}
      addAsGift={addAsGift}
      arrowsMobile={arrowsMobile}
    />
  ) : null;
};
